import * as React from "react";
import clsx from "clsx";
import { FieldErrors } from "react-hook-form";
import { StyledText } from "../../../assets/typography/typography";
import { colors } from "../../../components/colors";

interface Props {
  name: string;
  label?: string;
  helpText?: string;
  required?: boolean;
  defaultValue?: string | number | string[] | undefined;
  type?: string;
  register: any;
  errors?: FieldErrors<any>;
  // we eventually want to switch to error message string completely
  // instead of sending entire errors object
  errorMessage?: string;
  form?: any;
  formGroup?: boolean;
  onBlur?: any;
  onKeyDown?: any;
  id?: any;
  min?: number | string;
  max?: number | string;
  step?: string;
  children?: React.ReactNode;
}

export const InputFormField: React.FC<Props> = (props) => {
  const errors = props.errors;
  const hasError = !!errors?.[props.name];
  const errorMessageString = errors?.[props.name]?.message as string;
  const type = props.type ?? "text";
  const helpText = props.helpText;

  return (
    <div
      className={clsx({
        "form-group w-100":
          props.formGroup !== undefined ? props.formGroup : true,
        "has-error w-100": hasError,
      })}
    >
      {props.label && (
        <StyledText
          color={colors.textPrimary}
          className="bodySubtextSemibold mb-2"
        >
          {props.label}
        </StyledText>
      )}
      <input
        className="form-control"
        type={type}
        form={props.form}
        {...props.register(props.name as any)}
        required={props.required}
        onBlur={props.onBlur}
        step={props.step}
        onKeyDown={props.onKeyDown}
        id={props.id}
        min={props.min}
        max={props.max}
        defaultValue={props.defaultValue}
      />
      {props.errorMessage && (
        <StyledText
          color={colors.errorDark}
          className="bodySubtextRegular mt-2 mb-0"
        >
          {props.errorMessage}
        </StyledText>
      )}
      {!props.errorMessage && hasError && (
        <StyledText
          color={colors.errorDark}
          className="bodySubtextRegular mt-2 mb-0"
        >
          {errorMessageString}
        </StyledText>
      )}
      {helpText && !hasError && !props.errorMessage && (
        <StyledText
          color={colors.textSecondary}
          className="bodySubtextRegular mt-2 mb-0"
        >
          {helpText}
        </StyledText>
      )}
    </div>
  );
};
